import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import { Link } from "react-router-dom";
import {
  BoxMotion,
  TypographyMotion,
} from "components/elements/material_motion";

export default function NavigationBar() {
  const navigation = useSelector((state) => state.navigationReducer);

  return (
    <Box
      sx={{
        alignSelf: "flex-end",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 1,
        position: "relative",
      }}
    >
      <Box sx={{ display: "flex", gap: 5 }}>
        <Link to={"/"} style={{ textDecoration: "none" }}>
          <TypographyMotion
            animate={{ opacity: navigation.index === 0 ? 1 : 0.4 }}
            transition={{ type: "spring", duration: 1 }}
            variant="h5"
            sx={{
              fontFamily: "Poppins",
              fontWeight: 600,
              fontSize: 14,
              color: "black",
            }}
          >
            Home
          </TypographyMotion>
        </Link>
        <Link to={"/pendidikan"} style={{ textDecoration: "none" }}>
          <TypographyMotion
            animate={{ opacity: navigation.index === 1 ? 1 : 0.4 }}
            transition={{ type: "spring", duration: 1 }}
            variant="h5"
            sx={{
              fontFamily: "Poppins",
              fontWeight: 600,
              fontSize: 14,
              color: "black",
            }}
          >
            Pendidikan
          </TypographyMotion>
        </Link>
        <Link to={"/pengalaman"} style={{ textDecoration: "none" }}>
          <TypographyMotion
            animate={{ opacity: navigation.index === 2 ? 1 : 0.4 }}
            transition={{ type: "spring", duration: 1 }}
            variant="h5"
            sx={{
              fontFamily: "Poppins",
              fontWeight: 600,
              fontSize: 14,
              color: "black",
            }}
          >
            Pengalaman
          </TypographyMotion>
        </Link>
        <Link to={"/projek"} style={{ textDecoration: "none" }}>
          <TypographyMotion
            animate={{ opacity: navigation.index === 3 ? 1 : 0.4 }}
            transition={{ type: "spring", duration: 1 }}
            variant="h5"
            sx={{
              fontFamily: "Poppins",
              fontWeight: 600,
              fontSize: 14,
              color: "black",
            }}
          >
            Projek
          </TypographyMotion>
        </Link>
      </Box>
      <Box
        sx={{
          height: 3,
          borderRadius: 3,
          width: "calc(100% + 80px)",
          background: "rgba(255, 255, 255, 0.31)",
          backdropFilter: "blur(6.5px)",
        }}
      />
      <BoxMotion
        animate={{ x: navigation.position }}
        transition={{ type: "spring", duration: 1 }}
        sx={{
          height: "6px",
          position: "absolute",
          bottom: 0,
          left: 0,
          width: 30,
          borderRadius: "3px 3px 0px 0px",
          background: "#3672E9",
          boxShadow: "0px 2px 4px 0px rgba(54, 114, 233, 0.25)",
        }}
      />
    </Box>
  );
}
